import '/components/point-of-sale-map/point-of-sale-map';
